import isURL from 'validator/lib/isURL'

import avatarDefault from 'assets/avatar-loading-xxl.svg'

const MISSING_AVATAR_PATH = '/avatars/original/missing.png'

export const DEFAULT_AVATAR = avatarDefault

export const resolveUserAvatarUrl = (rawAvatar?: string | null): string => {
  if (!rawAvatar || rawAvatar === MISSING_AVATAR_PATH) {
    return DEFAULT_AVATAR
  }

  if (isURL(rawAvatar, { require_protocol: true })) {
    return rawAvatar
  }

  return DEFAULT_AVATAR
}
